<div
  [ngStyle]="{ 'width.%': isMobile ? 100 : tableWidthPercentage }"
  class="table-block lg-container"
  lgContainer
>
  <div lgRow>
    <div [lgCol]="12">
      @if (headingComponent) {
        <dotcom-frontend-loader [componentData]="headingComponent" />
      }

      <div class="table-block__container">
        <table
          [ngClass]="[headerPosition + '-headers', 'bg-color--' + tableColour]"
          lg-table
        >
          <thead lg-table-head>
            <tr lg-table-row>
              @for (headCell of headCells; let i = $index; track i) {
                <th
                  [innerHTML]="headCell['contentLink']['expanded']['cellText']"
                  [ngStyle]="{
                    'width.%':
                      !isVerticalHeader && !isMobile
                        ? headCell['contentLink']['expanded'][
                            'columnWidthPercentage'
                          ]
                        : null
                  }"
                  lg-table-head-cell
                ></th>
              }
            </tr>
          </thead>
          <tbody lg-table-body>
            @for (row of tableBodyRows; let i = $index; track i) {
              <tr
                [ngClass]="
                  row['contentLink']['expanded']['highlightRow']
                    ? 'highlight'
                    : ''
                "
                [ngStyle]="{
                  'width.%':
                    isVerticalHeader && !isMobile
                      ? row['contentLink']['expanded']['tableCells'][0][
                          'contentLink'
                        ]['expanded']['columnWidthPercentage']
                      : null
                }"
                lg-table-row
              >
                @for (
                  cell of row["contentLink"]["expanded"]["tableCells"];
                  let i = $index;
                  track i
                ) {
                  <td
                    [attr.rowspan]="cell['contentLink']['expanded']['rowSpan']"
                    [colspan]="cell['contentLink']['expanded']['columnSpan']"
                    [ngClass]="
                      cell['contentLink']['expanded']['highlightCell']
                        ? 'highlightCell'
                        : ''
                    "
                    lg-table-cell
                  >
                    <div
                      [innerHTML]="cell['contentLink']['expanded']['cellText']"
                      class="wysiwyg"
                    ></div>

                    @if (
                      !cell["contentLink"]["expanded"]["cellText"] &&
                      !cell["contentLink"]["expanded"]["cellCTA"]
                    ) {
                      <div
                        [ngClass]="{
                          'table-cell-icon':
                            cell['contentLink']['expanded']['icon']
                        }"
                      >
                        <i
                          [class]="
                            'wysiwyg-icon__' +
                            cell['contentLink']['expanded']['icon']
                          "
                          class="wysiwyg-icon"
                        ></i>
                      </div>
                    }

                    @if (
                      !cell["contentLink"]["expanded"]["cellText"] &&
                      cell["contentLink"]["expanded"]["cellCTA"]
                    ) {
                      <dotcom-frontend-button
                        [data]="{
                          buttonStyle:
                            cell['contentLink']['expanded']['cellCTA'][
                              'buttonStyle'
                            ],
                          text: cell['contentLink']['expanded']['cellCTA'][
                            'text'
                          ],
                          href: cell['contentLink']['expanded']['cellCTA'][
                            'href'
                          ],
                          title:
                            cell['contentLink']['expanded']['cellCTA']['title'],
                          extension:
                            cell['contentLink']['expanded']['cellCTA'][
                              'extension'
                            ],
                          fileSize:
                            cell['contentLink']['expanded']['cellCTA'][
                              'fileSize'
                            ],
                          icon:
                            cell['contentLink']['expanded']['cellCTA']['icon'],
                          target:
                            cell['contentLink']['expanded']['cellCTA']['target']
                         }"
                        class="table-block__button"
                      />
                    }
                  </td>
                }
              </tr>
            }
          </tbody>
        </table>
        <div
          [ngClass]="['bg-panel-mobile__' + tableColour]"
          class="bg-panel-mobile"
        ></div>
      </div>
    </div>
  </div>

  @if (followUpButtons) {
    <div lgRow>
      <div [lgCol]="12">
        @for (button of followUpButtons; let i = $index; track i) {
          <dotcom-frontend-loader
            [componentData]="button"
            cssClass="followup-cta-button"
          />
        }
      </div>
    </div>
  }
</div>
